import getCanPlayDash from "selectors/device/getCanPlayDash";
import getCanPlayFallbackDash from "selectors/device/getCanPlayFallbackDash";
import getCanPlayLegacyDash from "selectors/device/getCanPlayLegacyDash";
import getIsEdge from "selectors/device/getIsEdge";
import { createSelector } from "reselect";

export default createSelector(
  [getCanPlayDash, getCanPlayFallbackDash, getCanPlayLegacyDash, getIsEdge],
  (canPlayDash, canPlayFallbackDash, canPlayLegacyDash, isEdge) =>
    (canPlayDash || canPlayLegacyDash || canPlayFallbackDash) && !isEdge,
);
